import { Route } from "react-router-dom";
import { CostsOverview } from "./CostsOverview";

export const getCostsScene = () => (
  <Route path="costs" element={<CostsOverview />} />
);
